import type { NumberInputProps } from '@mantine/core'
import { NumberInput } from 'components/NumberInput/NumberInput'

type TInputWithUnit = Omit<NumberInputProps, 'type'> & {
  label: string
  unit: string
}

export const NumberInputWithUnit = ({ label, unit, ...numberInputProps }: TInputWithUnit) => {
  return (
    <div>
      <div css={{ fontWeight: 500, fontSize: 16, marginBottom: 5, display: 'flex', flexDirection: 'row' }}>
        {label}
      </div>
      <div css={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10 }}>
        <NumberInput
          hideControls
          css={{ maxWidth: 240 }}
          removeTrailingZeros={true}
          precision={10}
          {...numberInputProps}
        />
        <div css={{ fontWeight: 400, fontSize: 16 }}>{unit}</div>
      </div>
    </div>
  )
}
